import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import shoppingCartView from './views/shoppingCartView.js';
import shoppingCartMessageView from './views/shoppingCartMessageView.js';
import navigationView from './views/navigationView.js';
import homepageView from './views/homepageView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';
import shoppingCartView from './views/shoppingCartView.js';
import swal from 'sweetalert';

// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////
// if (module.hot) {
//   module.hot.accept();
// }

const controlRecipes = async function () {
  try {
    const id = window.location.hash.slice(1);

    if (!id) return;
    recipeView.renderSpinner();

    // 0) Update result view to mark selected search result
    resultsView.update(model.getSearchResultsPage());

    // 1) Update bookmarks view
    bookmarksView.update(model.state.bookmarks);

    // 2)Loading Recipe
    await model.loadRecipe(id);

    // 3) Rendering Recipe
    recipeView.render(model.state.recipe);

    // 4)hide the sort button in each search
    //model.state.search.sorted = false;
  } catch (err) {
    recipeView.renderError();
  }
};

//add to shopping cart btn controller
const controlShoppingCart = function () {
  const list = model.addToShoppingList();
  if (list === -1) {
    swal({
      title: 'This Recipe is already in the Shopping Cart',
      icon: 'info',
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Ok',
    });
  } else {
    shoppingCartView.render(list);
  }
};

//Nav cart btn controller
const controlShowShoppingCart = function () {
  renderCartView();
};

const controlSearchResults = async function () {
  try {
    resultsView.renderSpinner();

    // 1) Get search query
    const query = searchView.getQuery();
    if (!query) return;

    // 2) Load search result
    await model.loadSearchResults(query);

    // 3) show sort button only when there is data in the state.search.results array
    model.state.search.results.length > 0
      ? resultsView._showSortBtn(true)
      : resultsView._showSortBtn(false);

    // 4) Render results
    resultsView.render(model.getSearchResultsPage());

    // 5) Render initial pagination button
    paginationView.render(model.state.search);

    // 6) In each new search make the sorted state false
    model.state.search.sorted = false;

    // 7) In each new search remove highlight from sort button
    resultsView.highlightSortBtn(false);
  } catch (err) {
    console.log(err);
  }
};

const sortBtnHandler = function () {
  //toggling sorted state from true to fales in each click
  model.state.search.sorted = !model.state.search.sorted;

  //when sort btn is click sort the recipe results
  model.sortResults();

  // Render results after sorting
  resultsView.render(model.getSearchResultsPage());

  //highlight sort button method
  resultsView.highlightSortBtn(model.state.search.sorted);
};

const controlPagination = function (goToPage) {
  // 1) Render New results
  resultsView.render(model.getSearchResultsPage(goToPage));

  // 2) Render New pagination button
  paginationView.render(model.state.search);
};

const controlServings = function (newServings) {
  // Update the recipe servings (in state)
  model.updateServings(newServings);

  //Update the recipe view
  recipeView.update(model.state.recipe);
};

const controlBookmark = function () {
  // 1)Add/Remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  // 2) Update recipe view
  recipeView.update(model.state.recipe);

  // 3) Render bookmark
  bookmarksView.render(model.state.bookmarks);
};

const controlBookmarksLoad = function () {
  bookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    //show loading spinner when the data load
    addRecipeView.renderSpinner();

    //Upload the new recipe data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //Render recipe
    recipeView.render(model.state.recipe);

    //Success message
    addRecipeView.renderMessage();

    //Render the bookmark view
    bookmarksView.render(model.state.bookmarks);

    //Change ID in URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //Close form window
    setTimeout(function () {
      addRecipeView.toggleWindow();
      //location.reload();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(`😎 ${err}`);
    addRecipeView.renderError(err.message);
  }
};

//removeItem from shopping list controler
const controlRemoveCartItem = function (removeItemIndex) {
  swal({
    title: 'Confirm!',
    text: 'Are You Sure you Want to Delete this Item',
    confirmButtonColor: '#DD6B55',
    icon: 'warning',
    buttons: ['No', 'Yes'],
  }).then(function (value) {
    if (value) {
      model.removeShoppingListItem(removeItemIndex);
      shoppingCartView.renderCartNotificationOnRemove(model.state.shoppingList);
      renderCartView();
    } else {
      return;
    }
  });
};

const renderCartView = function () {
  model.state.shoppingList.length === 0
    ? shoppingCartMessageView.render(model.state.shoppingList)
    : shoppingCartView.render(model.state.shoppingList);
};

//this function is important do not delete
const viewRecipeFromCart = function () {
  //not empty
};

//this function is important do not delete
const recipePrintControler = function () {
  //not empty
};

const controlPageLoads = function () {};

const controlOpenNavigation = function () {};

const controlLogoBtn = function () {
  homepageView.render(model.state);
};

const init = function () {
  bookmarksView.addHandlerRender(controlBookmarksLoad);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerBookmark(controlBookmark, model.state.bookmarks);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
  resultsView.addHandlerClick(sortBtnHandler);
  recipeView.addHandlerCart(controlShoppingCart, model.state.shoppingList);
  shoppingCartView.addHandlerNavCartBtn(controlShowShoppingCart);
  shoppingCartView.addHandlerRemoveItem(controlRemoveCartItem);
  shoppingCartView.addHandlerViewRecipe(viewRecipeFromCart);
  shoppingCartView.addHandlerPrintRecipe(recipePrintControler);
  shoppingCartView.cartNotifyOnPageLoad(
    controlPageLoads,
    model.state.shoppingList
  );
  recipeView.bookmarkNotifyOnPageLoad(controlPageLoads, model.state.bookmarks);
  navigationView.showNavOnClick(controlOpenNavigation);
  navigationView.closeNavOnOverlayClick(controlOpenNavigation);
  homepageView.addHandlerLogoBtn(controlLogoBtn);
};
init();
